import React, { useEffect, useState, useContext, useRef } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import axios from 'axios';

import { faCopy } from '@fortawesome/free-solid-svg-icons';

import BugReportIcon from '@mui/icons-material/BugReport';

import { GlobalTypes } from '../../../../types/global';
import { GlobalContext } from '../../../../context/GobalState';
import { api, apiRecords } from '../../../../api/api';
import { formatDuration, formatPhoneNumber } from 'helpers';

import Button from '../../Button/Button';
import Eye from 'components/molecules/VisiblityEye/VisiblityEye';

import { StyledHeader, AudioRow, HeaderInfo, Icon } from './ModalContent.styles';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/system';

import ModalFlow from 'components/atoms/ModalFlow/ModalFlow';
import ModalQuality from 'components/atoms/ModalQuality/ModalQuality';

const ModalContent = ({ data, isActive, setLastOpenItemId, tabValue, setTabValue }) => {
  const [connectionData, setConnectionData] = useState([]);
  const [talkId, setTalkId] = useState('');
  const [recFilePath, setRecFilePath] = useState('');
  const [blobUrl, setBlobUrl] = useState('');
  const [spaceBetween] = useState(true);
  const [isExpert, setIsExpert] = useState(false);

  // const [tabValue, setTabValue] = useState(0);
  const { authToken, permissionLevel } = useContext(GlobalContext);
  const handleError = useErrorHandler();
  const audioRef = useRef();

  useEffect(() => {
    if (permissionLevel === GlobalTypes.PERMISSION_LEVEL_E) {
      setIsExpert(true);
    }
    if (permissionLevel === GlobalTypes.PERMISSION_LEVEL_P) {
      setIsExpert(false);
    }
  }, [permissionLevel]);

  useEffect(() => {
    setLastOpenItemId(talkId);
  }, [setLastOpenItemId, talkId]);

  useEffect(() => {
    if (isActive && data && authToken) {
      axios
        .get(`${api}data/data/${data.map((el) => el.talk_id)}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(
          ({ data }) => {
            setConnectionData(data);
            data.rec_file_path ? setRecFilePath(data.rec_file_path) : setRecFilePath('');
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .catch((error) => {
          alert('Something went wrong');
          console.log(error);
        });
    }

    if (!isActive) {
      setConnectionData([]);
    }
  }, [data, isActive, authToken, handleError]);

  useEffect(() => {
    if (!isActive) {
      updateAudioPlayer('');
    }
  }, [isActive]);

  useEffect(() => {
    if (!!recFilePath && isActive) {
      (async () => {
        const headers = new Headers();
        const username = 'voicetel';
        const password = 'IGai7phoPh';
        headers.set('Authorization', 'Basic ' + btoa(username + ':' + password));

        const result = await fetch(`${apiRecords}${recFilePath}`, {
          headers: headers,
        });
        const blob = await result.blob();

        if (blob) {
          updateAudioPlayer(URL.createObjectURL(blob));
        } else {
          console.warn('Error while downloading a blob');
          updateAudioPlayer('');
        }
      })();
    } else {
      updateAudioPlayer('');
    }
  }, [recFilePath, isActive]);

  useEffect(() => {
    data[0]?.talk_id && setTalkId(data[0].talk_id);
  }, [data]);

  const updateAudioPlayer = (sourceUrl) => {
    setBlobUrl(sourceUrl);
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.load();
    }
  };

  const copyToClipboard = (text) => {
    const elem = document.createElement('textarea');
    elem.value = text;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
  };

  const {
    duration,
    lead_number,
    phone_number,
    start_time,
    business_status,
    logical_status,
    technical_status,
    processing_status,
    tags,
    ab_scenario,
  } = connectionData;

  const jiraTicket = () => {
    axios
      .post(
        `${api}data/jira_issue/`,
        {
          vee_skill: 'Pudełko',
          lead_number: lead_number,
          phone_number: phone_number,
          start_time: start_time,
          panel_link: `${window.location.origin}${window.location.pathname}/!${talkId}`,
          logical_status: business_status,
        },
        {
          headers: {
            Authorization: `token ${authToken}`,
          },
        }
      )
      .then((response) => {
        let responseHtml = response.data.url;
        window.open(responseHtml, '_blank');
      });
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <StyledHeader>
        <HeaderInfo>
          <div>
            <Eye talk_id={talkId} />
          </div>
          <div>
            <span>Lead ID:</span>
            <p>{lead_number && lead_number}</p>
          </div>
          <div>
            <span>Talk ID:</span>
            <p>{talkId && talkId}</p>
          </div>
          <div>
            <span>Phone number:</span>
            <p>{phone_number && formatPhoneNumber(phone_number)}</p>
          </div>
          <div>
            <span>Start time:</span>
            <p>{start_time && start_time}</p>
          </div>
          <div>
            <span>Duration:</span>
            <p>{duration && formatDuration(duration)}</p>
          </div>
          <div>
            <span>Scenario:</span>
            <p>{ab_scenario && ab_scenario}</p>
          </div>
          <div>
            <span>Tag:</span>
            <p>{tags && tags.toString()}</p>
          </div>
        </HeaderInfo>
        <HeaderInfo spaceBetween={spaceBetween}>
          <div>
            <span>Business Status:</span>
            <p>{business_status && business_status}</p>
          </div>
          <div>
            <span>Technical Status:</span>
            <p>{technical_status && technical_status}</p>
          </div>
          <div>
            <span>Processing Status:</span>
            <p>{processing_status && processing_status}</p>
          </div>
        </HeaderInfo>
        <HeaderInfo>
          <div>
            <span>Logical Statuses:</span>
            <p>{logical_status && logical_status}</p>
          </div>
        </HeaderInfo>
        <AudioRow>
          {isExpert ? (
            <Box>
              <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example" sx={{ minHeight: '40px' }}>
                <Tab label="Flow" sx={{ minHeight: '40px', padding: '0 16px' }} />
                <Tab label="Quality" sx={{ minHeight: '40px', padding: '0 16px' }} />
              </Tabs>
            </Box>
          ) : (
            ''
          )}

          <audio ref={audioRef} controls style={{ margin: '0 24px 0 12px', position: 'relative' }}>
            <source src={blobUrl} type="audio/mpeg" />
          </audio>
          <div style={{ height: '25px' }}>
            <Button
              contained
              white
              onClick={() => copyToClipboard(`${window.location.origin}${window.location.pathname}/!${talkId}`)}
            >
              <Icon icon={faCopy} style={{ width: '1.2rem' }} />
            </Button>

            {/* <Button onClick={jiraTicket} contained white>
              <BugReportIcon /> Report
            </Button> */}
          </div>
        </AudioRow>
      </StyledHeader>
      {isExpert ? (
        <>
          <ModalFlow
            data={data}
            isActive={isActive}
            setLastOpenItemId={setLastOpenItemId}
            tabValue={tabValue}
            index={0}
          />
          <ModalQuality
            data={data}
            isActive={isActive}
            setLastOpenItemId={setLastOpenItemId}
            tabValue={tabValue}
            index={1}
          />
        </>
      ) : (
        ''
      )}
    </>
  );
};
export default ModalContent;
